import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { NavPageWrapper } from "../common/Nav";
import { PageLastLoaded } from "../common/PageLastLoaded";
import { default as ScorecardToolbar } from "./ScorecardToolbar";
import { default as ScorecardItem } from "./ScorecardItem";

export class Scorecard extends Component {
  constructor(props) {
    super(props)
    
    this.createScorecards = this.createScorecards.bind(this);
    
    if(this.props.actions.fetchAgentScorecardsAction) {
        this.props.actions.fetchAgentScorecardsAction({ 
          managementUnitID: props.User.managementUnitID,
          scorecardUserTypeId: 1
      });
    }
  }

  createScorecards() {
    
    if(this.props.scorecards !== undefined && this.props.scorecards.length > 0) {
      let scorecardsRender = [];

      this.props.scorecards.forEach(c => {
          let scorecard = JSON.parse(JSON.stringify(c))
          scorecardsRender.push(
            <ScorecardItem key={c.scorecardId} scorecard={scorecard} />
          )
      })
      return scorecardsRender;
    }
  }

  render() {
    
    return (
      <NavPageWrapper currPath={this.props.match.path}>
        
        <PageLastLoaded />
        <span className="right note_text"><strong>Note:</strong> Work day is defined as 3AM to 3AM Eastern Time</span>
        <ScorecardToolbar scorecards={this.props.scorecards} />
        <div className="scoreCard-wrapper">
          { this.createScorecards() }
        </div>
        

      </NavPageWrapper>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    scorecards: state.scorecard.scorecards,
    User: state.common.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Scorecard);



// WEBPACK FOOTER //
// ./src/features/scorecard/Scorecard.js